export function isExchangeAddress(addr) {
    return addr.pathArray[0] === 2;
}
export function isChangeAddress(addr) {
    return addr.pathArray[0] === 1;
}
export function isReceiveAddress(addr) {
    return addr.pathArray[0] === 0;
}
const requiredKeyIdentifierProps = ['derivationAlgorithm', 'derivationPath', 'keyType'];
export function isKeyIdentifierLike(obj) {
    return (typeof obj === 'object' &&
        obj !== null &&
        requiredKeyIdentifierProps.every((prop) => Object.hasOwn(obj, prop)));
}
